export default {"src":"/sg/_next/static/media/foldarrow.6a731bfe.svg","height":10,"width":10,"blurWidth":0,"blurHeight":0};